// Load responsive photos ahead of scrolling; never defer twice via native lazy loading.
function loadLPPhoto(img) {
 if(!img.dataset.src)return;
 img.loading='eager';
 if(img.dataset.srcset){img.srcset=img.dataset.srcset;delete img.dataset.srcset;}
 img.src=img.dataset.src;delete img.dataset.src;
}
const deferredPhotos=document.querySelectorAll('img[data-src]');
if('IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.isIntersecting){loadLPPhoto(entry.target);observer.unobserve(entry.target);}
 }),{rootMargin:'800px 160px'});
 deferredPhotos.forEach(img=>observer.observe(img));
 // Nested horizontal scroll areas clip IntersectionObserver margins: explicitly warm the next card.
 document.querySelectorAll('[data-rail-track]').forEach(track=>{
  function warm(){
   const box=track.getBoundingClientRect();
   if(box.bottom < -200 || box.top > innerHeight+800)return;
   track.querySelectorAll('img[data-src]').forEach(img=>{
    const r=img.getBoundingClientRect();
    if(r.right>box.left-box.width && r.left<box.right+box.width)loadLPPhoto(img);
   });
  }
  let queued=false;
  track.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;warm();});}},{passive:true});
  const railObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting)warm();},{rootMargin:'800px 0px'});
  railObserver.observe(track);
 });
}else deferredPhotos.forEach(loadLPPhoto);
'use strict';
const sizes = Object.freeze({
  S: { width: 65, height: 45 },
  M: { width: 80, height: 55 }
});
function recordIntent(event, parameters) {
  // ページ内の操作記録。MetaへのLP閲覧・LINEクリック計測はmeta-pixel.jsが同意状態に従って処理する。
  // LINEへの遷移クリックであり、友だち追加完了とは区別する。
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...parameters });
}
// LINE管理画面で発行した経路URL。現在のURLだけで判定し、Cookieや個人IDを保存しない。
const lineRouteParams = new URLSearchParams(window.location.search);
const isMetaTeaserVisit = ['meta', 'facebook', 'instagram'].includes((lineRouteParams.get('utm_source') || '').toLowerCase())
  && (lineRouteParams.get('utm_medium') || '').toLowerCase() === 'paid_social'
  && lineRouteParams.get('utm_campaign') === 'inunoibasho_teaser_20260915';
const lineRouteUrl = isMetaTeaserVisit ? 'https://lin.ee/RdClq4c' : 'https://lin.ee/PdFxHOu';
document.querySelectorAll('a[data-line]').forEach(link => {
  link.href = lineRouteUrl;
});
// 通常のリンクとして遷移し、JavaScript無効時も友だち追加画面へ進める。
document.querySelectorAll('a[data-line]').forEach(link => {
  link.addEventListener('click', () => {
    recordIntent('line_outbound_click', { placement: link.dataset.line });
  });
});
document.querySelectorAll('[data-size]').forEach(button => {
  button.addEventListener('click', () => {
    const key = button.dataset.size;
    const size = sizes[key];
    document.querySelectorAll('[data-size]').forEach(option => {
      const selected = option === button;
      option.classList.toggle('selected', selected);
      option.setAttribute('aria-pressed', String(selected));
    });
    document.querySelector('#size-width').textContent = `${size.width} cm`;
    document.querySelector('#size-height').textContent = `${size.height} cm`;
    document.querySelector('#size-letter').textContent = key;
    document.querySelector('#size-svg-title').textContent = `${key}サイズの寸法目安図`;
    document.querySelector('#size-svg-desc').textContent = `オーバル型、長辺${size.width}センチメートル、短辺${size.height}センチメートル。仕上がり寸法は予定です。`;
    document.querySelector('#size-status').textContent = `${key}サイズの寸法目安を表示しています。`;
    recordIntent('size_select', { size: key });
  });
});
const sticky = document.querySelector('.sticky-cta');
// Show the mobile action whenever no inline action is fully visible.
// Observe layout shifts and detail expansion as well as ordinary scrolling.
const inlineLineLinks = [...document.querySelectorAll('a[data-line]')].filter(a => !a.closest('.sticky-cta,dialog'));
function updateSticky() {
  const visibleInline = inlineLineLinks.some(a => {
    const r=a.getBoundingClientRect();
    return r.width > 0 && r.top >= 0 && r.bottom <= window.innerHeight;
  });
  const visible = window.matchMedia('(max-width: 760px)').matches && !visibleInline;
  sticky.classList.toggle('is-visible',visible);
  sticky.inert=!visible;
}
let stickyFrame=0;
function scheduleSticky(){if(!stickyFrame)stickyFrame=requestAnimationFrame(()=>{stickyFrame=0;updateSticky();});}
window.addEventListener('scroll',scheduleSticky,{passive:true});
window.addEventListener('resize',scheduleSticky);
document.addEventListener('toggle',scheduleSticky,true);
if('ResizeObserver' in window)new ResizeObserver(scheduleSticky).observe(document.querySelector('main'));
updateSticky();

// 写真の参照先はHTMLから取得し、画像埋め込み版でも同じ動作にする。
const gallerySection = document.querySelector('#gallery');
const galleryThumbs = Array.from(document.querySelectorAll('[data-gallery-index]'));
const galleryDialog = document.querySelector('#gallery-dialog');
const galleryOpen = document.querySelector('#gallery-open');
const galleryMainImage = document.querySelector('#gallery-image');
const galleryDialogImage = document.querySelector('#gallery-dialog-image');
let galleryIndex = Math.max(0, galleryThumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
let galleryReturnFocus = galleryOpen;
const galleryPhotos = galleryThumbs.map(thumb => {
  const img = thumb.querySelector('img');
  return {
    src: img.dataset.fullSrc || img.getAttribute('src'), preview: img.dataset.src || img.getAttribute('src'), srcset: img.dataset.srcset || img.getAttribute('srcset'), alt: img.alt,
    title: thumb.dataset.title, category: thumb.dataset.category,
    description: thumb.dataset.description,
    width: img.getAttribute('width'), height: img.getAttribute('height')
  };
});
const photoZoom = createPhotoZoom(galleryDialog, galleryDialogImage, delta => showGalleryPhoto(galleryIndex + delta));
let fullPhotoRequest = 0;
function showGalleryPhoto(index, loadFull = galleryDialog.open, readyPreview = "") {
  galleryIndex = (index % galleryPhotos.length + galleryPhotos.length) % galleryPhotos.length;
  const photo = galleryPhotos[galleryIndex];
  const request = ++fullPhotoRequest;
  for (const img of [galleryMainImage, ...(loadFull ? [galleryDialogImage] : [])]) {
    delete img.dataset.src; delete img.dataset.srcset;
    if (img === galleryMainImage) { img.srcset = photo.srcset || ""; img.src = photo.preview; }
    else {
      img.removeAttribute('srcset'); img.loading='eager';
      const thumb=galleryThumbs[galleryIndex].querySelector('img');
      const cached=readyPreview || (thumb.complete && thumb.naturalWidth>1 ? thumb.currentSrc : '');
      img.src=cached || photo.preview;
      const full=new Image(); full.decoding='async';
      full.onload=async()=>{
        try{await full.decode();}catch(_){}
        if(request===fullPhotoRequest && galleryDialog.open)img.src=photo.src;
      };
      full.src=photo.src;
    }
    img.alt = photo.alt;
    img.setAttribute('width', photo.width);
    img.setAttribute('height', photo.height);
  }
  galleryOpen.setAttribute('aria-label', `${photo.title} 写真を拡大する`);
  document.querySelector('#gallery-category').textContent = photo.category;
  document.querySelector('#gallery-photo-title').textContent = photo.title;
  document.querySelector('#gallery-description').textContent = photo.description;
  document.querySelector('#gallery-dialog-title').textContent = photo.title;
  const position = `${String(galleryIndex + 1).padStart(2, '0')} / ${String(galleryPhotos.length).padStart(2, '0')}`;
  document.querySelector('#gallery-count').textContent = position;
  document.querySelector('#gallery-count').setAttribute('aria-label', `${galleryPhotos.length}枚中${galleryIndex + 1}枚目`);
  document.querySelector('#gallery-dialog-count').textContent = position;
  galleryThumbs.forEach((thumb, i) => {
    thumb.classList.toggle('is-selected', i === galleryIndex);
    thumb.setAttribute('aria-pressed', String(i === galleryIndex));
  });
  photoZoom.setPhoto(photo);
}
function openGalleryPhoto(index, trigger) {
  const visible=trigger.querySelector('img');
  const preview=visible && visible.complete && visible.naturalWidth>1 ? visible.currentSrc : '';
  showGalleryPhoto(index, true, preview);
  galleryReturnFocus = trigger;
  galleryDialog.showModal();
  document.body.classList.add('gallery-modal-open');
  photoZoom.open();
}
galleryThumbs.forEach((thumb, i) => thumb.addEventListener('click', () => openGalleryPhoto(i, thumb)));
document.querySelectorAll('[data-photo-index]').forEach(button => {
  button.addEventListener('click', () => openGalleryPhoto(Number(button.dataset.photoIndex), button));
});
document.querySelectorAll('[data-gallery-prev]').forEach(button => button.addEventListener('click', () => showGalleryPhoto(galleryIndex - 1)));
document.querySelectorAll('[data-gallery-next]').forEach(button => button.addEventListener('click', () => showGalleryPhoto(galleryIndex + 1)));
function handleGalleryKey(event) {
  if (event.altKey || event.ctrlKey || event.metaKey) return;
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  event.preventDefault();
  if (event.key === 'Home') showGalleryPhoto(0);
  else if (event.key === 'End') showGalleryPhoto(galleryPhotos.length - 1);
  else showGalleryPhoto(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
  if (event.target.closest('.gallery-thumb')) {
    galleryThumbs[galleryIndex].scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
    galleryThumbs[galleryIndex].focus({preventScroll:true});
  }
}
gallerySection.addEventListener('keydown', handleGalleryKey);
galleryDialog.addEventListener('keydown', handleGalleryKey);
function bindGallerySwipe(surface) {
  const gesture = { start: null, suppressClick: false };
  surface.addEventListener('pointerdown', event => {
    gesture.suppressClick = false;
    if (event.pointerType === 'touch' && event.isPrimary !== false) {
      gesture.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
    }
  });
  surface.addEventListener('pointerup', event => {
    if (!gesture.start || gesture.start.id !== event.pointerId) return;
    const dx = event.clientX - gesture.start.x;
    const dy = event.clientY - gesture.start.y;
    gesture.start = null;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      gesture.suppressClick = true;
      event.preventDefault();
      showGalleryPhoto(galleryIndex + (dx < 0 ? 1 : -1));
    }
  });
  surface.addEventListener('pointercancel', () => { gesture.start = null; });
  return gesture;
}
const stageGesture = bindGallerySwipe(galleryOpen);
galleryOpen.addEventListener('click', () => {
  if (stageGesture.suppressClick) { stageGesture.suppressClick = false; return; }
  openGalleryPhoto(galleryIndex, galleryOpen);
});
document.querySelector('#gallery-close').addEventListener('click', () => galleryDialog.close());
galleryDialog.addEventListener('click', event => {
  if (event.target !== galleryDialog) return;
  const rect = galleryDialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) galleryDialog.close();
});
galleryDialog.addEventListener('close', () => {
  document.body.classList.remove('gallery-modal-open');
  photoZoom.close();
  galleryReturnFocus.focus({ preventScroll: true });
});

// Keep documentary evidence separate from the product photographs.
const reportDialog = document.querySelector('#test-report-dialog');
let reportReturnFocus = null;
document.querySelectorAll('[data-report-open]').forEach(button => {
  button.addEventListener('click', () => {
    reportReturnFocus = button;
    reportDialog.showModal();
    document.body.classList.add('report-modal-open');
  });
});
document.querySelector('#test-report-close').addEventListener('click', () => reportDialog.close());
reportDialog.addEventListener('click', event => {
  if (event.target !== reportDialog) return;
  const rect = reportDialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) reportDialog.close();
});
reportDialog.addEventListener('close', () => {
  document.body.classList.remove('report-modal-open');
  if (reportReturnFocus) reportReturnFocus.focus({ preventScroll: true });
});

// The floating menu remains available at every page scroll position.
const pageMenu = document.querySelector('#page-menu-dialog');
const pageMenuOpen = document.querySelector('#page-menu-open');
let menuDestination = null;
pageMenuOpen.addEventListener('click', () => {
  menuDestination = null;
  pageMenu.showModal();
  pageMenuOpen.setAttribute('aria-expanded', 'true');
  document.body.classList.add('menu-modal-open');
});
document.querySelector('#page-menu-close').addEventListener('click', () => pageMenu.close());
document.querySelectorAll('[data-menu-link]').forEach(link => {
  link.addEventListener('click', event => {
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    menuDestination = target;
    pageMenu.close();
  });
});
pageMenu.addEventListener('click', event => {
  if (event.target !== pageMenu) return;
  const rect = pageMenu.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) pageMenu.close();
});
pageMenu.addEventListener('close', () => {
  document.body.classList.remove('menu-modal-open');
  pageMenuOpen.setAttribute('aria-expanded', 'false');
  if (menuDestination) {
    const destination = menuDestination;
    menuDestination = null;
    destination.setAttribute('tabindex', '-1');
    destination.focus({ preventScroll: true });
    destination.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  } else {
    pageMenuOpen.focus({ preventScroll: true });
  }
});

// A contained photo viewport: browser/page zoom is not used.
function createPhotoZoom(dialog, img, changePhoto) {
  const frame = dialog.querySelector('.gallery-dialog-frame');
  const minus = dialog.querySelector('#gallery-zoom-out');
  const plus = dialog.querySelector('#gallery-zoom-in');
  const fit = dialog.querySelector('#gallery-zoom-fit');
  const label = dialog.querySelector('#gallery-zoom-level');
  const DEFAULT_ZOOM = 1.5;
  const state = { scale: DEFAULT_ZOOM, x: 0, y: 0, width: 0, height: 0, frameWidth: 0, frameHeight: 0 };
  const pointers = new Map();
  let start = null, pinch = null, dragged = false, hadPinch = false, suppressClick = false;

  function render() {
    if (!state.width || !state.height) return;
    const maxX = Math.max(0, (state.width * state.scale - state.frameWidth) / 2);
    const maxY = Math.max(0, (state.height * state.scale - state.frameHeight) / 2);
    state.x = Math.max(-maxX, Math.min(maxX, state.x));
    state.y = Math.max(-maxY, Math.min(maxY, state.y));
    img.style.width = `${state.width}px`;
    img.style.height = `${state.height}px`;
    img.style.transform = `translate(-50%, -50%) translate(${state.x}px, ${state.y}px) scale(${state.scale})`;
    const percent = `${Math.round(state.scale * 100)}%`;
    if (label.textContent !== percent) label.textContent = percent;
    minus.disabled = state.scale <= 1.001;
    plus.disabled = state.scale >= 3.999;
    fit.disabled = state.scale <= 1.001;
    frame.classList.toggle('is-zoomed', state.scale > 1.001);
  }
  function measure() {
    if (!dialog.open) return;
    const rect = frame.getBoundingClientRect();
    const width = Number(img.getAttribute('width')), height = Number(img.getAttribute('height'));
    if (!rect.width || !rect.height || !width || !height) return;
    const ratio = Math.min(rect.width / width, rect.height / height);
    const oldWidth = state.width;
    state.width = width * ratio; state.height = height * ratio;
    state.frameWidth = rect.width; state.frameHeight = rect.height;
    if (oldWidth) { state.x *= state.width / oldWidth; state.y *= state.width / oldWidth; }
    render();
  }
  function point(clientX, clientY) {
    const rect = frame.getBoundingClientRect();
    return { x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2 };
  }
  function zoomTo(value, anchor = { x: 0, y: 0 }) {
    const next = Math.max(1, Math.min(4, value));
    const ratio = next / state.scale;
    state.x = anchor.x - (anchor.x - state.x) * ratio;
    state.y = anchor.y - (anchor.y - state.y) * ratio;
    state.scale = next;
    render();
  }
  function releasePointers() {
    for (const id of pointers.keys()) {
      if (frame.hasPointerCapture(id)) frame.releasePointerCapture(id);
    }
    pointers.clear(); start = pinch = null;
    frame.classList.remove('is-dragging');
  }
  function reset() {
    releasePointers(); state.scale = DEFAULT_ZOOM; state.x = state.y = 0;
    measure();
  }
  function beginPinch() {
    const [a, b] = [...pointers.values()];
    pinch = { distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)),
      center: point((a.x + b.x) / 2, (a.y + b.y) / 2), scale: state.scale, x: state.x, y: state.y };
  }
  minus.addEventListener('click', () => zoomTo(state.scale - 0.5));
  plus.addEventListener('click', () => zoomTo(state.scale + 0.5));
  fit.addEventListener('click', () => zoomTo(1));
  frame.addEventListener('click', event => {
    if (suppressClick) { suppressClick = false; return; }
    zoomTo(state.scale < 2 ? 2 : 1, point(event.clientX, event.clientY));
  });
  frame.addEventListener('wheel', event => {
    event.preventDefault();
    const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? 200 : 1);
    zoomTo(state.scale * Math.exp(-delta * 0.0015), point(event.clientX, event.clientY));
  }, { passive: false });
  frame.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (!pointers.size) {
      dragged = hadPinch = suppressClick = false;
      start = { x: event.clientX, y: event.clientY, pointerType: event.pointerType, scale: state.scale };
    }
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    frame.setPointerCapture(event.pointerId);
    frame.focus({ preventScroll: true });
    if (pointers.size >= 2) { hadPinch = true; beginPinch(); }
    frame.classList.toggle('is-dragging', state.scale > 1);
  });
  frame.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId)) return;
    const previous = pointers.get(event.pointerId);
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size >= 2 && pinch) {
      const [a, b] = [...pointers.values()];
      const center = point((a.x + b.x) / 2, (a.y + b.y) / 2);
      const scale = Math.max(1, Math.min(4, pinch.scale * Math.hypot(a.x - b.x, a.y - b.y) / pinch.distance));
      state.x = center.x - (pinch.center.x - pinch.x) * scale / pinch.scale;
      state.y = center.y - (pinch.center.y - pinch.y) * scale / pinch.scale;
      state.scale = scale; dragged = true; render();
    } else {
      if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 5) dragged = true;
      if (state.scale > 1) {
        state.x += event.clientX - previous.x; state.y += event.clientY - previous.y;
        render();
      }
    }
  });
  function endPointer(event) {
    if (!pointers.has(event.pointerId)) return;
    const oldStart = start;
    pointers.delete(event.pointerId);
    if (frame.hasPointerCapture(event.pointerId)) frame.releasePointerCapture(event.pointerId);
    suppressClick = dragged || hadPinch || event.type !== 'pointerup';
    if (pointers.size >= 2) beginPinch();
    else pinch = null;
    if (!pointers.size) {
      frame.classList.remove('is-dragging');
      if (event.type === 'pointerup' && !hadPinch && oldStart?.pointerType === 'touch' && oldStart.scale === 1) {
        const dx = event.clientX - oldStart.x, dy = event.clientY - oldStart.y;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) changePhoto(dx < 0 ? 1 : -1);
      }
      start = null;
    }
  }
  frame.addEventListener('pointerup', endPointer);
  frame.addEventListener('pointercancel', endPointer);
  frame.addEventListener('lostpointercapture', event => {
    if (pointers.has(event.pointerId)) endPointer(event);
  });
  frame.addEventListener('keydown', event => {
    if (event.ctrlKey || event.altKey || event.metaKey) return;
    if (['+', '=', '-', '0', 'Enter', ' '].includes(event.key)) {
      event.preventDefault(); event.stopPropagation();
      if (event.key === '0') zoomTo(1);
      else if (event.key === '-') zoomTo(state.scale - 0.5);
      else if (event.key === '+' || event.key === '=') zoomTo(state.scale + 0.5);
      else zoomTo(state.scale < 2 ? 2 : 1);
    } else if (state.scale > 1 && ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) {
      event.preventDefault(); event.stopPropagation();
      if (event.key === 'ArrowLeft') state.x += 60;
      if (event.key === 'ArrowRight') state.x -= 60;
      if (event.key === 'ArrowUp') state.y += 60;
      if (event.key === 'ArrowDown') state.y -= 60;
      render();
    }
  });
  img.addEventListener('load', measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(frame);
  window.addEventListener('resize', measure);
  return { setPhoto: reset, open: reset, close: releasePointers };
}


// Native overflow supports swiping; mouse dragging and keyboard access remain available.
document.querySelectorAll('[data-photo-rail]').forEach(rail => {
 const track=rail.querySelector('[data-rail-track]');
 // Keep the first floor scene stable; mix the remaining seven photos once per visit.
 if(rail.hasAttribute('data-shuffle-tail')){
  const tail=[...track.querySelectorAll('[data-rail-item]')].slice(1);
  for(let i=tail.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[tail[i],tail[j]]=[tail[j],tail[i]];}
  tail.forEach(item=>track.append(item));
 }
 const items=[...track.querySelectorAll('[data-rail-item]')];
 const controls=rail.querySelector('[data-rail-controls]');
 const count=rail.querySelector('[data-rail-count]');
 const isHero=rail.classList.contains('photo-rail--hero');
 let current=0,frame=0,drag=null,suppressClick=false;
 const motion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
 const positions=()=>{const origin=track.getBoundingClientRect().left;return items.map(el=>el.getBoundingClientRect().left-origin+track.scrollLeft);};
 function update(){
  frame=0;
  const left=track.scrollLeft,max=track.scrollWidth-track.clientWidth;
  const pos=positions();
  current=pos.reduce((best,x,i)=>Math.abs(x-left)<Math.abs(pos[best]-left)?i:best,0);
  const bounds=track.getBoundingClientRect();
  const visible=items.map((el,i)=>({i,r:el.getBoundingClientRect()})).filter(({r})=>Math.min(r.right,bounds.right)-Math.max(r.left,bounds.left)>=r.width*.5).map(({i})=>i);
  const first=isHero?current:(visible[0]??current),last=isHero?current:(visible.at(-1)??current);
  const label=(first===last?String(first+1).padStart(2,'0'):String(first+1).padStart(2,'0')+'–'+String(last+1).padStart(2,'0'))+' / '+String(items.length).padStart(2,'0');
  if(count.textContent!==label)count.textContent=label;
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(update);}
 function go(index,focus=false){
  index=Math.max(0,Math.min(items.length-1,index));
  track.scrollTo({left:positions()[index],behavior:motion()});
  if(focus){const target=items[index].matches('button')?items[index]:items[index].querySelector('button');target?.focus({preventScroll:true});}
 }
 controls.hidden=false;
 track.addEventListener('scroll',schedule,{passive:true});
 track.addEventListener('keydown',event=>{
  if(event.ctrlKey||event.altKey||event.metaKey||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();event.stopPropagation();
  const target=event.target.closest('[data-rail-item]');
  const from=target?items.indexOf(target):current;
  go(event.key==='Home'?0:event.key==='End'?items.length-1:from+(event.key==='ArrowRight'?1:-1),!!target);
 });
 // Mouse dragging supplements trackpad/touch scrolling without hijacking vertical touch gestures.
 track.addEventListener('pointerdown',event=>{
  suppressClick=false;
  if(event.pointerType!=='mouse'||event.button!==0)return;
  drag={x:event.clientX,y:event.clientY,left:track.scrollLeft,id:event.pointerId,moved:false};
 });
 track.addEventListener('pointermove',event=>{
  if(!drag||event.pointerId!==drag.id)return;
  const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
  if(!drag.moved&&Math.abs(dx)>7&&Math.abs(dx)>Math.abs(dy)){
   drag.moved=true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');
  }
  if(drag.moved){event.preventDefault();track.scrollLeft=drag.left-dx;}
 });
 function finish(event){
  if(!drag||event.pointerId!==drag.id)return;
  const moved=drag.moved;drag=null;
  if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);
  track.classList.remove('is-dragging');
  if(moved){suppressClick=true;schedule();}
 }
 track.addEventListener('pointerup',finish);track.addEventListener('pointercancel',finish);
 track.addEventListener('lostpointercapture',finish);
 track.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null;});
 track.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopImmediatePropagation();suppressClick=false;}},true);
 track.addEventListener('dragstart',event=>event.preventDefault());
 if('ResizeObserver' in window)new ResizeObserver(schedule).observe(track);
 update();
});


// Same colour animation encoded as a lightweight video; pause off screen.
(() => {
 const video=document.querySelector('#color-animation'), toggle=document.querySelector('#color-animation-toggle');
 if(!video || !toggle)return;
 const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
 let enabled=!preference.matches, visible=false;
 function sync(){
  toggle.textContent=enabled?'動きを止める':'動きを見る';toggle.setAttribute('aria-pressed',String(enabled));
  if(enabled && visible && !document.hidden){
   const source=video.querySelector('source[data-src]');
   if(source){source.src=source.dataset.src;delete source.dataset.src;video.load();}
   video.muted=true;video.play().catch(()=>{});
  }else video.pause();
 }
 toggle.hidden=false;toggle.addEventListener('click',()=>{enabled=!enabled;sync();});
 preference.addEventListener('change',()=>{enabled=!preference.matches;sync();});
 document.addEventListener('visibilitychange',sync);
 if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0.05}).observe(video);
 else visible=true;
 sync();
})();

// Silent, button-free films. Defer the second clip until its section is visible.
document.querySelectorAll('#intro-dogs-video, #material-dogs-video').forEach(video => {
  video.controls = false;
  video.defaultMuted = true;
  video.muted = true;
  video.loop = true;
  const initialBounds = video.getBoundingClientRect();
  let inView = initialBounds.bottom > 0 && initialBounds.top < window.innerHeight;
  const syncPlayback = () => {
    if (inView && !document.hidden) {
      const deferredSource = video.querySelector('source[data-src]');
      if (deferredSource) {
        deferredSource.src = deferredSource.dataset.src;
        deferredSource.removeAttribute('data-src');
        video.load();
      }
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    } else {
      video.pause();
    }
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold: 0.05});
    observer.observe(video);
  } else {
    inView = true;
  }
  document.addEventListener('visibilitychange', syncPlayback);
  video.addEventListener('loadedmetadata', syncPlayback);
  syncPlayback();
});
